/**
 * Dashboard daily-stats API seam (Spec 469) — BFF endpoint
 * GET /v1/admin/dashboard/daily-stats. Tenant scoping happens server-side
 * (applyTenantFilter); the FE only passes the window size.
 */
import { get } from './client';
import type { DailyStatsResponse } from '@/types/dashboard-stats';

export async function getDailyStats(days = 3): Promise<DailyStatsResponse> {
  return get<DailyStatsResponse>('/admin/dashboard/daily-stats', { days: String(days) });
}
